import React from 'react';
import MenuItem from './MenuItem';
import MyCourses from './MyCourses.png';
import Timetable from './Timetable.png';
import CourseStore from './CourseStore.png';
export default function MainMenuCard() {
    return (
        <>
            <MenuItem title="Мои курсы" imgSrc={MyCourses} navigateTo="/my-courses"/>
            {/* <MenuItem title="Умный справочник" isDisabled /> */}
            {/* <MenuItem title="Расписание" imgSrc={Timetable} navigateTo="/timetable"/> */}
            {/* <MenuItem title="Статистика" isDisabled /> */}
            <MenuItem title="Магазин курсов" imgSrc={CourseStore} navigateTo="/courses-store" />
        </>
    );
}
